import {useSelector} from 'react-redux';
import {selectTransaction, selectRecipient} from '../signerUiSlice';
import {REASSIGN_SCHEME_TYPES} from '@constants';

export default function useEnforcedReassignAuth() {
    const transaction = useSelector(selectTransaction);
    const recipient = useSelector(selectRecipient);

    const inPersonRoles = transaction?.roles || [];
    const currentRoleId = recipient?.id;

    if (!currentRoleId) {
        return null;
    }

    const currentRole = inPersonRoles.find(({id}) => id === currentRoleId);
    const currentAuth = currentRole?.auth || {};

    if (currentAuth?.scheme && currentAuth?.scheme !== REASSIGN_SCHEME_TYPES.EMAIL) {
        return currentAuth;
    }

    return null;
}
